import { render, staticRenderFns } from "./SkeletonDetails.vue?vue&type=template&id=280b9711&scoped=true&"
import script from "./SkeletonDetails.vue?vue&type=script&lang=js&"
export * from "./SkeletonDetails.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonDetails.vue?vue&type=style&index=0&id=280b9711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b9711",
  null
  
)

export default component.exports